'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<path d="M15.811 8.581l-5 7a1.003 1.003 0 0 1-.731.416 1.005 1.005 0 0 1-.79-.29l-3-3a1 1 0 1 1 1.415-1.414l2.165 2.165 4.314-6.039a1 1 0 0 1 1.627 1.162M11 0C4.93 0 0 4.93 0 11s4.93 11 11 11c6.06 0 11-4.93 11-11S17.06 0 11 0"/><!-- Filename: sourceSvg/action/select_selected.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};